import React from "react";
import { Box } from "@dxp-feed/ui/Box";
import { Text } from "@dxp-feed/ui/Text";
import { SiteContainer } from "@/components/Container";
import Link from "@/components/Link";

export default function QuickMenu({ quickLink }: any) {
  const quickMenuData = quickLink?.data?.mobileLinksList.items[0];

  const triggerHelpClick = () => {
    const button = document.querySelector('.helpButtonEnabled') as HTMLButtonElement | null; 
    if (button) {
      button.click();
      console.log("Clicked live chat button.");
    } else {
      console.warn("live chat button not found.");
    }
  };
 

  return (
    <Box>
      <Box
        as="div"
        className="px-6 top-header-action-icons py-[12px] border-t-[1px] border-grey350 lg:hidden bg-brandWhite"
      >
        <SiteContainer className="!pl-0">
          <Text as="ul" className="m-0 p-0 list-none block text-left">
            <Text as="li">
              <Link
                aria-label="Go to Contact Us page"
                target="_self"
                href={quickMenuData?.contactUs ? (quickMenuData.contactUs.startsWith("/") ? quickMenuData.contactUs : `/${quickMenuData.contactUs}`) : "#"}
                className="popins"
              >
                <Text
                  as="h6"
                  className="text-[14px] text-brandBlack font-normal leading-nxormal py-2"
                >
                  Contact Us
                </Text>
              </Link>
            </Text>
            <Text as="li">
              <Link
                aria-label="Open Help in a new tab"
                target={quickMenuData?.help ? "_self" : "_blank"}
                href={quickMenuData?.help || "#"}
                className="popins"
              >
                <Text
                  as="h6"
                  className="text-[14px] text-brandBlack font-normal leading-normal py-2"
                >
                  Help
                </Text>
              </Link>
            </Text>
            <Text as="li">
              {/* <Link
                aria-label="Start Live Chat in a new tab"
                target="_blank"
                href={quickMenuData?.liveChat || "#"}
                className="popins"
              > */}
              <Text
                as="h6"
                className="text-[14px] text-brandBlack font-normal leading-normal py-2"
                onClick={triggerHelpClick}
              >
                Live Chat
              </Text>
              {/* </Link> */}
            </Text>
            <Text as="li">
              <Link
                aria-label="Open Voila in a new tab"
                target="_blank"
                href={quickMenuData?.voila || "#"}
                className="popins"
              >
                <Text
                  as="h6"
                  className="text-[14px] text-brandBlack font-normal leading-normal py-2"
                >
                  Voila
                </Text>
              </Link>
            </Text>
            <Text as="li">
              <Link
                aria-label="Open Scene Plus in a new tab"
                target="_blank"
                href={quickMenuData?.scene || "#"}
                className="popins"
              >
                <Text
                  as="h6"
                  className="text-[14px] text-brandBlack font-normal leading-normal py-2"
                >
                  Scene+
                </Text>
              </Link>
            </Text>
          </Text>
        </SiteContainer>
      </Box>
    </Box>
  );
}
